import React from 'react';
import colorVariables from '@densityco/ui/variables/colors.json';

const ColoredPercent: React.FunctionComponent<{percent: number | null}> = ({percent}) => {
  if (percent === null) {
    return (
      <span style={{color: colorVariables.gray300, fontWeight: 500, userSelect: 'none'}}>
        Not yet calculated
      </span>
    );
  }

  let color = colorVariables.yellow;
  if (percent < 90) {
    color = colorVariables.red;
  }
  if (percent > 95) {
    color = colorVariables.green;
  }

  return (
    <span style={{color}}>
      {Math.round(percent * 100) / 100}%
    </span>
  );
};
export default ColoredPercent;
